import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function handleCallback() {
            try {
                // Handle authentication callback
                if (window.authService) {                    const userData = await window.authService.handleAuthCallback();
                    if (userData) {
                        setUser(userData);
                        navigate('/', { replace: true });
                    } else {
                        // If there's no user data, something went wrong
                        throw new Error('Authentication failed. Please try again.');
                    }
                } else {
                    throw new Error('Authentication service is not available');
                }
            } catch (err) {
                console.error('Auth callback error:', err);
                setError(err.message || 'Authentication failed. Please try again.');
            } finally {
                setLoading(false);
            }
        }

        handleCallback();
    }, [navigate, setUser]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="loader mb-4"></div>
                    <h2 className="text-xl text-gray-700">Completing your sign in...</h2>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="max-w-md w-full bg-white rounded-xl shadow-xl p-8 text-center">
                    <div className="text-red-600 text-5xl mb-4">
                        <i className="fas fa-exclamation-circle"></i>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Authentication Error</h2>
                    <p className="text-gray-600 mb-6">{error}</p>
                    <button 
                        onClick={() => navigate('/login')}
                        className="btn btn-primary"
                    >
                        Return to Login
                    </button>
                </div>
            </div>
        );
    }

    return null;
}

export default AuthCallback;
